import { render, staticRenderFns } from "./ViewHeadline.vue?vue&type=template&id=29583f2a&"
import script from "./ViewHeadline.vue?vue&type=script&lang=js&"
export * from "./ViewHeadline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports